import React, { useState, useEffect } from 'react';
import { debounce } from 'debounce';

const useWindowWidth = (dispatchWindowWidth = null) => {
  const [windowWidth, updateWindowWidth] = useState(null);

  const handleResize = () => {
    if (dispatchWindowWidth) {
      dispatchWindowWidth(window.innerWidth);
      return;
    }

    updateWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', debounce(handleResize, 300));

    return () => {
      window.removeEventListener('resize', debounce(handleResize, 300));
    };
  }, []);

  return windowWidth;
};

export default useWindowWidth;
